import { render, staticRenderFns } from "./BackgroundView.vue?vue&type=template&id=42be7ea2&scoped=true&"
import script from "./BackgroundView.vue?vue&type=script&lang=ts&"
export * from "./BackgroundView.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundView.vue?vue&type=style&index=0&id=42be7ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be7ea2",
  null
  
)

export default component.exports